import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'sourceStreamLastFrame';
export const useSourceStreamLastFrameTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => useTranslation('widgets', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    title: 'Трансляция',
    open_live: 'Открыть',
    configure_zones: 'Настроить зоны ROI/DROI',
    restream_error_title: 'Произошла ошибка при загрузке ретрансляции.',
    restream_error_message: 'Для настройки зон и угла поворота камеры можно воспользоваться текстовыми полями формы.',
    legend_title: 'Обозначения',
    legend: {
      inherits: 'наследует настройки группы',
      own: 'использует собственные настройки',
    },
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Live',
    open_live: 'Open',
    configure_zones: 'Configure ROI/DROI zones',
    restream_error_title: 'An error occurred while loading the retransmission.',
    restream_error_message: 'Use the text fields in the form to configure zones and camera rotation angle.',
    legend_title: 'Legend',
    legend: {
      inherits: 'inherits group settings',
      own: 'uses its own settings',
    },
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Transmisión',
    open_live: 'Abrir',
    configure_zones: 'Configurar zonas ROI/DROI',
    restream_error_title: 'Se produjo un error al cargar la retransmisión.',
    restream_error_message: 'Para configurar las zonas y el ángulo de rotación de la cámara, utilice los campos de texto del formulario.',
    legend_title: 'Leyenda',
    legend: {
      inherits: 'hereda la configuración del grupo',
      own: 'usa su propia configuración',
    },
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Transmissão',
    open_live: 'Abrir',
    configure_zones: 'Configurar zonas ROI/DROI',
    restream_error_title: 'Ocorreu um erro ao carregar a retransmissão.',
    restream_error_message: 'Para configurar as zonas e o ângulo de rotação da câmera, use os campos de texto do formulário.',
    legend_title: 'Legenda',
    legend: {
      inherits: 'herda as configurações do grupo',
      own: 'usa suas próprias configurações',
    },
  },
}) as Record<string, unknown>;
